/**
 * CallStatusBadge — wraps the shared {@link StatusBadge} for canonical call
 * statuses. Always renders a translated text label alongside the color dot, so
 * status is never conveyed by color alone (a11y + brand hard rule).
 */

import type { CallStatus } from '@hostesa/api-client';
import { useT } from '@hostesa/i18n';
import { StatusBadge } from '@hostesa/ui';
import { callStatusVariant } from './call-presentation';

export interface CallStatusBadgeProps {
  status: CallStatus;
  'data-testid'?: string;
}

export function CallStatusBadge({ status, 'data-testid': testId }: CallStatusBadgeProps) {
  const { t } = useT('calls');
  const label = t(`status.${status}`, { defaultValue: t('status.unknown') });
  return (
    <StatusBadge
      status={callStatusVariant(status)}
      label={label}
      data-testid={testId ?? `call-status-${status}`}
    />
  );
}
